module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "tab-details-wrapper"
    }
  }, [_c('div', {
    staticClass: "main-container",
    attrs: {
      "id": "main-detail-container"
    }
  }, [_c('div', {
    attrs: {
      "id": "main-value-detail-container"
    }
  }, [(_vm.establishtmentValue) ? _c('div', {
    staticClass: "col-xs-12"
  }, [_c('h4', {
    staticClass: "detail-title"
  }, [_vm._v(_vm._s(_vm.establishtmentValue.title))]), _c('h4', {
    staticClass: "tab-detail-value"
  }, [_vm._v(_vm._s(_vm.establishtmentValue.value))])]) : _vm._e(), _vm._l((_vm.mainValuesList), function(mainValue, index) {
    return _c('div', [_c('div', {
      staticClass: "col-xs-4"
    }, [_c('h4', {
      staticClass: "detail-title"
    }, [_vm._v(_vm._s(mainValue.title))]), _c('h4', {
      staticClass: "tab-detail-value"
    }, [_vm._v(_vm._s(mainValue.value))])]), (index > 1 && (index + 1) % 3 === 0) ? _c('div', {
      staticClass: "clear"
    }) : _vm._e()])
  }), (_vm.commentary) ? _c('div', {
    staticClass: "col-xs-12"
  }, [_c('h4', {
    staticClass: "detail-title"
  }, [_vm._v(_vm._s(_vm.commentary.title))]), _c('h4', {
    staticClass: "tab-detail-value"
  }, [_vm._v(_vm._s(_vm.commentary.value))])]) : _vm._e()], 2), _c('div', {
    staticClass: "status-container",
    attrs: {
      "id": "statuses-container"
    }
  }, _vm._l((_vm.statusValuesList), function(statusValue, index) {
    return _c('div', {
      staticStyle: {
        "text-align": "center"
      }
    }, [_c('div', {
      staticClass: "col-xs-6"
    }, [_c('h4', {
      staticClass: "detail-title"
    }, [_vm._v(_vm._s(statusValue.title))]), _c('h4', {
      class: statusValue.class
    }, [_vm._v(_vm._s(statusValue.value))])]), ((index + 1) % 2 === 0) ? _c('div', {
      staticClass: "clear"
    }) : _vm._e()])
  }), 0)]), _c('div', {
    attrs: {
      "id": "footer-monetary-detail-container"
    }
  }, [_c('div', {
    staticClass: "col-xs-12 monetary-container"
  }, [_c('div', {
    staticClass: "col-xs-12 px-0"
  }, _vm._l((_vm.monetaryValuesList), function(monetaryValue, index) {
    return _c('div', [_c('div', {
      staticClass: "col-xs-4"
    }, [_c('h4', {
      staticClass: "tab-detail-value"
    }, [_vm._v(_vm._s(monetaryValue.title))]), _c('h4', {
      class: monetaryValue.class
    }, [_vm._v(_vm._s(monetaryValue.value))])]), ((index + 1) % 3 === 0) ? _c('div', {
      staticClass: "clear"
    }) : _vm._e()])
  }), 0)]), _c('div', {
    staticClass: "clear"
  })])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-0affa294", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0affa294"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./client/components/modals/gridDetailsModal/tabDetails/tabDetails.pug
// module id = 1364
// module chunks = 0